































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { Settings, TenantSettings } from "@/shared/core/services/configService";
import { CrudService } from "@/shared/core/services/crudService";
import { ShopService } from "@/shared/core/services/shopService";
import { LocalStorage } from "@/shared/core/localStorage";
import { CustomerHelper } from "@/shared/crm/helpers/customerHelper";
import store from "@/shared/core/store";

@Component
export default class AccountMenu extends Vue {
  @Prop({ type: Boolean, default: false }) inline!: boolean;

  settings: TenantSettings = {};
  hasPrograms: boolean = false;
  hasReports: boolean = false;

  get isLoggedIn() {
    return store.state.loggedIn === true;
  }

  get firstName(): string {
    try {
      const raw = LocalStorage.getWithTimeout("cc");
      if (raw === null || raw === undefined) {
        return "";
      }
      const customer = JSON.parse(raw);
      const name = (customer.name || "").toString().trim();
      return name.split(" ")[0] || "";
    } catch {
      return "";
    }
  }

  // CodeScanner registration of the dynamic keys below:
  // $t("Good morning") $t("Good afternoon") $t("Good evening")
  get greetingKey(): string {
    const hour = new Date().getHours();
    if (hour < 12) {
      return "Good morning";
    }
    if (hour < 20) {
      return "Good afternoon";
    }
    return "Good evening";
  }

  async mounted() {
    this.settings = store.state.settings;
    if (this.isLoggedIn) {
      this.hasPrograms =
        (await this.anyProgram(
          `customer/${CustomerHelper.getStoredCustomer()}`,
        )) || (await this.anyProgram("list"));
      const reports = await new CrudService().httpGet(
        `${Settings.HostName}/api/publicreports/customer/${CustomerHelper.getStoredCustomer()}`,
      );
      this.hasReports = reports != null && reports.ok === true && reports.data.length > 0;
    }
  }

  async anyProgram(path: string): Promise<boolean> {
    const data = await new CrudService().httpGet(
      `${Settings.HostName}/api/publicprogrampacks/${path}`,
    );
    return data != null && data.ok === true && data.data.length > 0;
  }

  close() {
    this.$emit("close");
  }

  openLogin(register: boolean) {
    LocalStorage.add("loginModeOn", register);
    this.close();
    store.commit("openLogin");
  }

  logout() {
    this.close();
    new ShopService().removeCart();
    CustomerHelper.logOut();
    window.location.reload();
  }
}
